import PropTypes from 'prop-types';

import Missing from '~/components/Elements/Missing';

import ItemRenderer from './ItemRenderer';
import ShoeSymbolValue from './ShoeSymbolValue';

const Shoes = ({
  currentStart,
  isPreliminary = true,
  preliminaryEquipment,
  previousStart,
  showTooltip,
  symbolSize = 20,
  variant = 'text',
  className,
}) => {
  let shoes;
  let shoeId;
  let isFirstTime = false;
  let isPreliminaryShoes = false;

  if (isPreliminary) {
    if (preliminaryEquipment) {
      shoes = preliminaryEquipment.shoes;
      shoeId = preliminaryEquipment.shoe_id;
      isFirstTime = preliminaryEquipment.shoes_first;
      isPreliminaryShoes = true;
    }

    if (currentStart && currentStart.shoe_id) {
      if (currentStart.shoe_id !== shoeId) {
        shoes = currentStart.shoes;
        shoeId = currentStart.shoe_id;
        isFirstTime = false;
      }

      isPreliminaryShoes = false;
    }
  } else if (currentStart) {
    shoes = currentStart.shoes;
    shoeId = currentStart.shoe_id;
  }

  const previousShoes = previousStart != null ? previousStart.shoes : undefined;
  const previousShoeId =
    previousStart != null ? previousStart.shoe_id : undefined;

  const isChanged =
    shoeId != null &&
    previousShoeId != null &&
    previousShoeId !== 'U' &&
    shoeId !== previousShoeId;

  if (!shoeId || shoeId === 'U' || (currentStart && currentStart.scratched)) {
    return <Missing />;
  }

  return (
    <ItemRenderer
      isFirstTime={isFirstTime}
      changed={isChanged}
      showTooltip={showTooltip}
      previousValue={previousShoes}
      className={className}
    >
      {variant === 'text' && shoes}
      {variant === 'symbol' && (
        <ShoeSymbolValue
          isPreliminaryShoes={isPreliminaryShoes}
          changed={isChanged}
          shoeId={shoeId}
          shoes={shoes}
          size={symbolSize}
        />
      )}
    </ItemRenderer>
  );
};

Shoes.propTypes = {
  currentStart: PropTypes.object,
  isPreliminary: PropTypes.bool,
  preliminaryEquipment: PropTypes.object,
  previousStart: PropTypes.object,
  showTooltip: PropTypes.bool,
  symbolSize: PropTypes.number,
  variant: PropTypes.oneOf(['text', 'symbol']),
  className: PropTypes.string,
};

export default Shoes;
